"use strict";

var _classCallCheck = require("/home/gitlab-runner/builds/o6jZzivs/0/root/rf-kiln/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/gitlab-runner/builds/o6jZzivs/0/root/rf-kiln/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadEmittersPlugin = void 0;

var Utils_1 = require("../../Utils");

var Emitters_1 = require("./Emitters");

var Enums_1 = require("./Enums");

var Emitter_1 = require("./Options/Classes/Emitter");

var EmittersPlugin = /*#__PURE__*/function () {
  function EmittersPlugin() {
    _classCallCheck(this, EmittersPlugin);

    this.id = "emitters";
  }

  _createClass(EmittersPlugin, [{
    key: "getPlugin",
    value: function getPlugin(container) {
      return new Emitters_1.Emitters(container);
    }
  }, {
    key: "needsPlugin",
    value: function needsPlugin(options) {
      var _a, _b, _c;

      if (options === undefined) {
        return false;
      }

      var emitters = options.emitters;
      return emitters instanceof Array && !!emitters.length || emitters !== undefined || !!((_c = (_b = (_a = options.interactivity) === null || _a === void 0 ? void 0 : _a.events) === null || _b === void 0 ? void 0 : _b.onClick) === null || _c === void 0 ? void 0 : _c.mode) && Utils_1.isInArray(Enums_1.EmitterClickMode.emitter, options.interactivity.events.onClick.mode);
    }
  }, {
    key: "loadOptions",
    value: function loadOptions(options, source) {
      var _a, _b;

      if (!this.needsPlugin(options) && !this.needsPlugin(source)) {
        return;
      }

      var optionsCast = options;

      if (source === null || source === void 0 ? void 0 : source.emitters) {
        if ((source === null || source === void 0 ? void 0 : source.emitters) instanceof Array) {
          optionsCast.emitters = source === null || source === void 0 ? void 0 : source.emitters.map(function (s) {
            var tmp = new Emitter_1.Emitter();
            tmp.load(s);
            return tmp;
          });
        } else {
          var emitterOptions = optionsCast.emitters;

          if ((emitterOptions === null || emitterOptions === void 0 ? void 0 : emitterOptions.load) === undefined) {
            optionsCast.emitters = emitterOptions = new Emitter_1.Emitter();
          }

          emitterOptions.load(source === null || source === void 0 ? void 0 : source.emitters);
        }
      }

      var interactivityEmitters = (_b = (_a = source === null || source === void 0 ? void 0 : source.interactivity) === null || _a === void 0 ? void 0 : _a.modes) === null || _b === void 0 ? void 0 : _b.emitters;

      if (interactivityEmitters) {
        if (interactivityEmitters instanceof Array) {
          optionsCast.interactivity.modes.emitters = interactivityEmitters.map(function (s) {
            var tmp = new Emitter_1.Emitter();
            tmp.load(s);
            return tmp;
          });
        } else {
          var _emitterOptions = optionsCast.interactivity.modes.emitters;

          if ((_emitterOptions === null || _emitterOptions === void 0 ? void 0 : _emitterOptions.load) === undefined) {
            optionsCast.interactivity.modes.emitters = _emitterOptions = new Emitter_1.Emitter();
          }

          _emitterOptions.load(interactivityEmitters);
        }
      }
    }
  }]);

  return EmittersPlugin;
}();

function loadEmittersPlugin(tsParticles) {
  var plugin = new EmittersPlugin();
  tsParticles.addPlugin(plugin);
}

exports.loadEmittersPlugin = loadEmittersPlugin;